import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './Home'
import Orders from './Orders'
import Wishlist from './Wishlist'
import Address from './Address'
import Cards from './Cards'
import Notifications from './Notifications'
import Settings from './Settings'

export default function Index() {
    return (
        <>
            <Routes>
                <Route index element={<Home />} />
                <Route path='/orders' element={<Orders />} />
                <Route path='/wishlist' element={<Wishlist />} />
                <Route path='/address' element={<Address />} />
                <Route path='/cards' element={<Cards />} />
                <Route path='/notifications' element={<Notifications />} />
                <Route path='/settings' element={<Settings />} />
            </Routes>
        </>
    )
}
